import { da } from "./da";
import { en } from "./en";
import type { LegalDoc, LegalDocId } from "./types";

export type { LegalDoc, LegalDocId, LegalSection } from "./types";

export const LEGAL_DOC_IDS = ["privacy", "terms", "dpa", "cookies"] as const satisfies readonly LegalDocId[];

const DOCS = { en, da } as const;

export function legalDoc(id: LegalDocId, locale: "en" | "da"): LegalDoc {
  return DOCS[locale][id];
}
